// REACT & REACT HOOKS
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

// STORE ACTIONS
import { getAllPayments } from "store/actions";

// COMPONENTS
import ControlArea from "components/Layout/control-area";
import BootyPagination from "components/shared/pagination";
import TableControl from "components/shared/table";

// ICONS & ASSETS
import Icon from "./assets/payment.svg";

// HELPERS
import { handleErrMsg } from "helpers/functions";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";

const Payments = () => {
    const { payments, loading, error } = useSelector((state) => state.payments);
    const dispatch = useDispatch();
    const { formatMessage, locale } = useIntl();
    const [isDispatched, setIsDispatched] = useState(false);
    const [searchParams] = useSearchParams();

    useEffect(() => {
        setIsDispatched(true);
        dispatch(getAllPayments(searchParams));
    }, [dispatch, searchParams]);

    // error
    useEffect(() => {
        if (error && isDispatched) {
            toastErrorMessage(
                formatMessage({ id: handleErrMsg(error) }),
                locale
            );
        }
    }, [error, formatMessage, locale, isDispatched]);

    const columns = [
        {
            name: <FormattedMessage id="paymentId" />,
            selector: (row) => row?.paymentId,
            sortable: true,
        },
        {
            name: <FormattedMessage id="netAmount" />,
            selector: (row) => row?.netAmount,
            sortable: true,
        },
        {
            name: <FormattedMessage id="transferFees" />,
            selector: (row) => row?.transferFees,
            sortable: true,
        },
        {
            name: <FormattedMessage id="withholdingTax" />,
            selector: (row) => row?.withholdingTax,
            sortable: true,
        },
        {
            name: <FormattedMessage id="tax" />,
            selector: (row) => row?.tax,
            sortable: true,
        },
        {
            name: <FormattedMessage id="expectedPaymentAmount" />,
            selector: (row) => row?.expectedPaymentAmount,
            sortable: true,
        },
        {
            name: <FormattedMessage id="transactionDate" />,
            selector: (row) => row?.transactionDate?.split("T")?.[0],
            sortable: true,
        },
        {
            name: <FormattedMessage id="paymentStatus" />,
            selector: (row) => <FormattedMessage id={row?.paymentStatus} />,
            sortable: true,
        },
    ];
    return (
        <div className="applications-wrap">
            <ControlArea
                cardTxt={<FormattedMessage id={"payments"} />}
                icon={Icon}
            />
            <TableControl
                title={"paymentsTableShow"}
                columns={columns}
                data={payments}
                loading={loading}
            />
            <BootyPagination metaData={payments?.metadata} />
        </div>
    );
};

export default Payments;
